import './Maintenance.css';

const MaintenancePage = () => {
  return (
    <div className="maintenance-container">
      <img src="/logo.png" alt="MyTop25 Logo" className="nav-logo" />
      <p className="maintenance-kicker">Be right back</p>
      <h1>The locker room is closed for a minute</h1>
      <p>We are hanging new rankings, tightening a few bolts, and grabbing water.</p>
      <p>Check back soon. The polls will be here when you return.</p>
    </div>
  );
};

export default MaintenancePage;
